import { Injectable } from '@angular/core';
import {ApiService} from './api.service';


export const experiencedayStatuses = {
  Concept: 'Concept',
  OpenForRegistration: 'OpenForRegistration',
  RegistrationClosed: 'RegistrationClosed'
}

/**
 * @deprecated Use `ExperienceDayService` from
 * `src/app/api/services/experience-day.service.ts`. This hand-written wrapper
 * predates the generated client, returns `Observable<any>`, and will be
 * removed once all callers have migrated.
 */
@Injectable({
  providedIn: 'root'
})
export class ExperiencedayService {

  constructor(private api: ApiService) {


  }

  /**
   * Api create company experience day
   *
   * @param $companyId
   * @param $params
   */
  apiCreateCompanyExperienceday($companyId: string, $params: any) {

    const params:any = {
      companyId: $companyId,
      status: $params['status'],
      title: $params['title'],
      description: $params['description'],
      minStudents: $params['minStudents'],
      maxStudents: $params['maxStudents'],
      possibleDates: $params['possibleDates']
    }

    this.api.setEndpoint('company/' + $companyId + '/experienceday');
    return this.api.POST(params);
  }

  /**
   * Api update company experience day
   *
   * @param $companyId
   * @param $params
   */
  apiUpdateCompanyExperienceday($companyId: string, $id:string, $params: any) {

    const params:any = {
      id: $id,
      companyId: $companyId,
      status: $params['status'],
      title: $params['title'],
      description: $params['description'],
      minStudents: $params['minStudents'],
      maxStudents: $params['maxStudents'],
      possibleDates: $params['possibleDates'],
    }

    this.api.setEndpoint('company/' + $companyId + '/experienceday/' + $id);
    return this.api.PUT(params);
  }

  /**
   * Api update company experience day
   *
   * @param $companyId
   * @param $params
   */
  apiDeleteCompanyExperienceday($companyId: string, $id:string) {
    this.api.setEndpoint('company/' + $companyId + '/experienceday/' + $id);
    return this.api.DELETE();
  }

  /**
   * Api call to get company's all experience days
   *
   * @param $companyId
   */
  apiGetCompanyExperiencedays($companyId: string, $queryParams:any = null){

    this.api.setEndpoint('company/' + $companyId + '/experienceday');
    return this.api.GET($queryParams);
  }

  /**
   * Api call to get company's all experience days
   *
   * @param $companyId
   */
  apiGetCompanyPlannedExperiencedays($companyId: string, $queryParams:any = null){

    this.api.setEndpoint('company/' + $companyId + '/plannedexperienceday');
    return this.api.GET($queryParams);
  }

  /**
   * Api update company experience day
   *
   * @param $companyId
   * @param $params
   */
  apiUpdateCompanyPlannedExperienceday($companyId: string, $id:string, $params: any) {

    const params:any = $params;

    this.api.setEndpoint('company/' + $companyId + '/plannedexperienceday/' + $id);
    return this.api.PUT(params);
  }

  /**
   * Api call to get company's all experience days
   *
   * @param $companyId
   */
  apiGetExperiencedays($queryParams:any = null){

    this.api.setEndpoint('experienceday');
    return this.api.GET($queryParams);
  }
  /**
   * Post a date for an experience day
   *
   * @param $id
   * @param $date
   */
  apiCreateExperiencedayDate($id: string, $date: string) {
    this.api.setEndpoint( 'experienceday/' + $id);
    const params = {
      date: $date
    }
    return this.api.POST(params);
  }

  /**
   * Get all planned experience days of a student profile
   * @param $studentprofileId
   * @param $queryParams
   */
  apiGetStudentprofilePlannedexperiencedays($studentprofileId: string, $queryParams: any = null) {
    this.api.setEndpoint('studentprofile/' + $studentprofileId + '/plannedexperienceday');
    return this.api.GET($queryParams);
  }

  /**
   * Api delete studentprofile planned experience day
   *
   * @param $companyId
   * @param $params
   */
  apiDeleteStudentprofilePlannedExperienceday($studentprofileId: string, $id:string) {
    this.api.setEndpoint('studentprofile/' + $studentprofileId + '/plannedexperienceday/' + $id);
    return this.api.DELETE();
  }

  getStatusOptions() {
    return [
      {
        value: experiencedayStatuses.Concept,
        name: this.getStatusName(experiencedayStatuses.Concept)
      },
      {
        value: experiencedayStatuses.OpenForRegistration,
        name: this.getStatusName(experiencedayStatuses.OpenForRegistration)
      },
      {
        value: experiencedayStatuses.RegistrationClosed,
        name: this.getStatusName(experiencedayStatuses.RegistrationClosed)
      }

    ]
  }

  getStatusName($status:string) {
    let result = '';
    switch ($status) {
      case experiencedayStatuses.Concept:
        result = 'Concept';
        break;

      case experiencedayStatuses.OpenForRegistration:
        result = 'Open for registration';
        break;

      case experiencedayStatuses.RegistrationClosed:
        result = 'Closed for registration';
        break;
    }

    return result;
  }
}
